var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('c-menu', {
    staticClass: "the_side_nav",
    attrs: {
      "nudge-top": "0px",
      "align-left": "",
      "border-color": "var(--cosmic-text)",
      "border-size": "1px"
    },
    domProps: {
      "zebraStripeItems": true
    }
  }, [_c('ButtonMiniActionNavbar', {
    attrs: {
      "slot": "activator",
      "aria-label": "toggle menu",
      "aria-selected": "false",
      "disable-scale-on-hover": "",
      "icon-size": "22px",
      "icon": _vm.computedNavbarIcon,
      "tooltip-position": "bottom left",
      "tooltip": "Toggle menu"
    },
    slot: "activator"
  }), _vm._t("side_menu_items"), _c('hr', {
    staticClass: "my-2"
  }), _vm.currentUserIsAdmin ? _c('c-menu-item', {
    attrs: {
      "href": `/admin?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons['ADMIN'],
      "icon-color": "var(--cosmic-red-base)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Admin area "), _c('small', [_vm._v("Area for ADMIN Users")])])], 1)]) : _vm._e(), _vm.currentUserHasPermission(_vm.UserPermission.CHANGE_SET_TEMPLATE_ADMIN) ? _c('c-menu-item', {
    attrs: {
      "href": `/approval_templates/manage?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.EntityType.CHANGE_SET],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Change approval templates "), _c('small', [_vm._v("Set up base approval routing for different types of changes")])])], 1)]) : _vm._e(), _vm.currentUserHasPermission(_vm.UserPermission.USER_ADMIN) ? _c('c-menu-item', {
    attrs: {
      "href": `/users/search?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.EntityType.USER],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Manage Users "), _c('small', [_vm._v("View/update COSMIC Users")])])], 1)]) : _vm._e(), _vm.currentUserHasPermission(_vm.UserPermission.USER_GROUPS_ADMIN) ? _c('c-menu-item', {
    attrs: {
      "href": `/users/groups/search?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.EntityType.USER_GROUP],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Manage User Groups "), _c('small', [_vm._v("View/update COSMIC User Groups")])])], 1)]) : _vm._e(), _c('c-menu-item', {
    attrs: {
      "href": `/reporting?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons.application_reporting,
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Reporting "), _c('small', [_vm._v("View " + _vm._s(_vm.EsocApplicationDisplay.get(_vm.$cosmicApplication)) + " reports")])])], 1)]), _c('hr', {
    staticClass: "my-2"
  }), _vm.applicationVersion ? _c('c-menu-item', {
    on: {
      "c-click": _vm.onClickOfShowChangeLog
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap",
    staticStyle: {
      "font-size": "14px",
      "color": "var(--cosmic-text)"
    }
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": "fa-duotone fa-solid fa-wand-magic-sparkles",
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, sans-serif",
      "font-weight": "500"
    }
  }, [_vm._v(" View app updates ")]), _c('small', [_vm._v(" v"), _c('span', {
    staticClass: "monospace_font",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.applicationVersion))])])])], 1)]) : _vm._e(), _c('c-menu-item', {
    attrs: {
      "href": _vm.cosmicSupportRoute,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('img', {
    attrs: {
      "height": "30px",
      "src": _vm.cosmicSupportLogoSrc,
      "alt": "Navigate to COSMIC Support"
    }
  }), _c('c-icon-fa', {
    staticClass: "ml-3",
    attrs: {
      "icon": _vm.$icons['external_link'],
      "icon-size": "12px",
      "icon-color": "black"
    }
  })], 1)]), _c('c-menu-item', {
    attrs: {
      "href": _vm.cosmicKnowledgeBaseRoute,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('img', {
    attrs: {
      "height": "30px",
      "src": _vm.cosmicKnowledgeBaseLogoSrc,
      "alt": "Navigate to COSMIC Knowledge Base"
    }
  }), _c('c-icon-fa', {
    staticClass: "ml-3",
    attrs: {
      "icon": _vm.$icons['external_link'],
      "icon-size": "12px",
      "icon-color": "black"
    }
  })], 1)]), !_vm.isApplicationCdocs ? _c('c-menu-item', {
    attrs: {
      "href": _vm.cosmicDocumentsRoute,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('img', {
    attrs: {
      "height": "30px",
      "src": _vm.cosmicDocumentsLogoSrc,
      "alt": "Navigate to COSMIC Documents"
    }
  }), _c('c-icon-fa', {
    staticClass: "ml-3",
    attrs: {
      "icon": _vm.$icons['external_link'],
      "icon-size": "12px",
      "icon-color": "black"
    }
  })], 1)]) : _vm._e(), !_vm.isApplicationOg ? _c('c-menu-item', {
    attrs: {
      "href": _vm.cosmicOgRoute,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('img', {
    attrs: {
      "height": "30px",
      "src": _vm.cosmicOgLogoSrc,
      "alt": "Navigate to COSMIC IMS"
    }
  }), _c('c-icon-fa', {
    staticClass: "ml-3",
    attrs: {
      "icon": _vm.$icons['external_link'],
      "icon-size": "12px",
      "icon-color": "black"
    }
  })], 1)]) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };